import {gql} from "@irati/utils/gql"

import fullTeam from "../fragments/Team"
import {partialUserList} from "../fragments/PartialUser"

export default gql`
  mutation UpdateTeam($tenantId: String!, $data: TeamUpdateInput!, $totalOnly: Boolean) {
    updateTeam(tenantId: $tenantId, data: $data) {
      ...fullOldTeam
      users(totalOnly: $totalOnly) {
        ...partialUserList
      }
    }
  }
  ${fullTeam}
  ${partialUserList}
`
